// Approved MF icon logo (supplied artwork, unaltered); size ≈ visual height in px.
export function BrandMark({ size = 48, className = "" }) {
  return (
    <img src="/brand/Memories_Forever_Icon_MF.png" alt="Memories Forever" data-testid="brand-mark"
      style={{ height: size }} className={`w-auto select-none ${className}`} draggable="false" />
  );
}

// Approved full logo: MF mark + MEMORIES FOREVER (supplied artwork, tagline set as live text by the caller).
export function BrandLogo({ className = "" }) {
  return (
    <img src="/brand/Memories_Forever_Logo.png" alt="Memories Forever" data-testid="hero-wordmark"
      className={`w-auto select-none ${className}`} draggable="false" />
  );
}
